import { DeletePasskeyActionTypes, FetchPasskeysActionTypes, RenamePasskeyActionTypes, SETUP_PASSKEY_FROM_NUDGE, SKIP_PASSKEY_SETUP_NUDGE, ValidatePasskeyActionTypes } from '../actions/PasskeysActions';
const initialState = {
  credentials: [],
  showPasskeyNudge: false
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case ValidatePasskeyActionTypes.SUCCESS:
      return Object.assign({}, state, {
        credentials: [...state.credentials, action.payload]
      });
    case FetchPasskeysActionTypes.SUCCESS:
      return Object.assign({}, state, {
        credentials: action.payload
      });
    case DeletePasskeyActionTypes.SUCCESS:
      return Object.assign({}, state, {
        credentials: state.credentials.filter(credential => credential.credentialId !== action.payload)
      });
    case RenamePasskeyActionTypes.SUCCESS:
      return Object.assign({}, state, {
        credentials: state.credentials.map(credential => {
          if (credential.credentialId === action.payload.credentialId) {
            return Object.assign({}, credential, {
              name: action.payload.name
            });
          } else {
            return credential;
          }
        })
      });
    case SETUP_PASSKEY_FROM_NUDGE:
      return Object.assign({}, state, {
        redirectUrl: action.payload.redirectUrl,
        showPasskeyNudge: true
      });
    case SKIP_PASSKEY_SETUP_NUDGE:
      return Object.assign({}, state, {
        showPasskeyNudge: false
      });
    default:
      return state;
  }
});